export default Object.freeze({
  StripeTransfer: 1,
  ManualSettlement: 2,
  None: 3,
});
